import { onCLS, onLCP, onINP } from 'web-vitals';

onCLS(console.log);
onINP(console.log);
onLCP(console.log);
